module.exports = __webpack_public_path__ + "static/localization-feature-news-8b06fc10054d1de24c7fdf573e922984.webm";